import * as React from 'react'

interface IInputWrapperProps {
  children: any
  title?: string
  className?: string
  optional?: boolean
  touched?: boolean
  error?: string
}

const InputWrapper = ({ children, title, optional, touched, error, className = '' }: IInputWrapperProps) => (
  <div className={'col-12 ' + className}>
    <div className='col-12 flex justify-between'>
      {!!title && <div className='h6'>{title}</div>}
      {optional && <div className='h6 font-light-blue-grey'>optional</div>}
    </div>
    {children}
    {!!(touched && error) && <div className='col-12 font-red h6 mt1'>{`Error: ${error}`}</div>}
  </div>
)

export default InputWrapper



// WEBPACK FOOTER //
// ./src/components/ui/InputWrapper.tsx